<template>
  <nuxt-img v-bind="$attrs" :src="src" :alt="alt" :loading="loading" v-on="$listeners"></nuxt-img>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';

/**
 * docs: https://github.com/nuxt/image
 */
export default defineComponent({
  name: 'OImage',
  props: {
    src: { type: String, required: true },
    alt: { type: String, default: undefined },
    /**
     * lazy load icin loading="lazy"
     */
    loading: { type: String, default: undefined },
  },
});
</script>
